export const getTabulatorHeight = (headerDiv, filterDiv) => {
    let mainHeaderHeight = document.getElementsByClassName('main-header')[0].offsetHeight;
    // let mainFooterHeight = document.getElementsByClassName('main-footer')[0].offsetHeight;
    let deviceHeaderHeight = typeof headerDiv === 'number' ? headerDiv : headerDiv.offsetHeight;
    let deviceFooterHeight = typeof filterDiv === 'number' ? filterDiv : filterDiv.offsetHeight;
    // return (window.innerHeight - mainHeaderHeight - deviceHeaderHeight - deviceFooterHeight - mainFooterHeight);
    return (window.innerHeight - mainHeaderHeight - deviceHeaderHeight - deviceFooterHeight);
}

export const convertBytes = (byteValue) => {
    let displayValue
    if (byteValue > 1125899906842624) {
      displayValue = convertStorageSize(byteValue, "Byte", "PB").toFixed(2);
      displayValue += " PB";
    } else if (byteValue > 1099511627776) {
      displayValue = convertStorageSize(byteValue, "Byte", "TB").toFixed(2);
      displayValue += " TB";
    } else if (byteValue > 1073741824) {
      displayValue = convertStorageSize(byteValue, "Byte", "GB").toFixed(2);
      displayValue += " GB";
    } else if (byteValue > 1048576) {
      displayValue = convertStorageSize(byteValue, "Byte", "MB").toFixed(2);
      displayValue += " MB";
    } else if (byteValue >= 1024) {
      displayValue = convertStorageSize(byteValue, "Byte", "KB").toFixed(2);
      displayValue += " KB";
    } else {
      displayValue = byteValue;
      displayValue += " Bytes";
    }
    return displayValue;
}

export const convertStorageSize = (size, fromUnit = "Byte", toUnit = "Byte") => {
  const units = ["Bit", "Byte", "KB", "MB", "GB", "TB", "PB"];
  const fromIndex = units.indexOf(fromUnit);
  const toIndex = units.indexOf(toUnit);
  
  if (fromIndex === -1 || toIndex === -1) {
    throw new Error("Invalid unit");
  } else if (fromIndex === toIndex) {
    return size;
  } else if (fromIndex < toIndex) {
    return size / Math.pow(1024, toIndex - fromIndex);
  } else {
    return size * Math.pow(1024, fromIndex - toIndex);
  }
}

export const showYUnit = (value, unit) => {
  let displayValue;

  if (unit) {
    displayValue = value;
    displayValue = displayValue + " " + unit;
  } else {
    displayValue = value;
  }

  return displayValue;
};

export const checkToShowTabulator = () => {
  let isNoData = document.querySelector(".custom-list-table span")?.innerHTML;
  let element = document.getElementsByClassName("custom-list-table");

  if (isNoData === "No data found") {
    element[0].classList.add("no-show-table");
  } else {
    element[0].classList.remove("no-show-table");
  }
};